import FieldInteger from './FieldInteger'

export { FieldInteger }
export default FieldInteger
